import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton } from '@mui/material';
import React from 'react';

type PackageImageCardProps = {
    imageBase64: string
    isMobile: boolean
    statusLabel?: string
    statusColor?: string
    onDelete: () => void
    deleteDisabled?: boolean
}

export const PackageImageCard: React.FC<PackageImageCardProps> = (props) => {
    return (
        <Box
            sx={{
                position: 'relative',
                display: 'inline-block',
                width: props.isMobile ? '100%' : '50%'
            }}
        >
            <img
                src={props.imageBase64}
                style={{ width: '100%', display: 'block' }}
            />
            {props.statusLabel && props.statusColor ?
                <Box
                    sx={{
                        position: 'absolute',
                        top: 8,
                        left: 8,
                        px: 0.75,
                        py: 0.25,
                        borderRadius: 1,
                        bgcolor: props.statusColor,
                        color: 'common.white',
                        fontSize: 11,
                        fontWeight: 700
                    }}
                >
                    {props.statusLabel}
                </Box>
                : undefined
            }
            <IconButton
                onClick={props.onDelete}
                disabled={props.deleteDisabled === true}
                sx={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    width: 24,
                    height: 24,
                    p: 0.25,
                    bgcolor: 'grey.500',
                    color: 'common.white',
                    '&:hover': {
                        bgcolor: 'grey.600'
                    },
                    '&.Mui-disabled': {
                        bgcolor: 'grey.300',
                        color: 'common.white'
                    }
                }}
            >
                <CloseIcon sx={{ fontSize: 14 }} />
            </IconButton>
        </Box>
    );
};